var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "26px",
    viewBox: "0 0 13 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB ico MENU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 11.8595294 0 11.8595294 25.9999639 0 25.9999639"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Design-v10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8-Footer",
    transform: "translate(-97.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social",
    transform: "translate(76.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FB-ico-MENU",
    transform: "translate(21.538462, 15.076923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56305882,5.03565833 L2.56305882,8.61426944 L0,8.61426944 L0,12.9912972 L2.56305882,12.9912972 L2.56305882,25.9999639 L7.82823529,25.9999639 L7.82823529,12.9927417 L11.3615294,12.9927417 C11.3615294,12.9927417 11.6925882,10.8939639 11.8538824,8.59874167 L7.84870588,8.59874167 L7.84870588,5.60549167 C7.84870588,5.15843611 8.42223529,4.55754722 8.99047059,4.55754722 L11.8595294,4.55754722 L11.8595294,-3.61111111e-05 L7.95776471,-3.61111111e-05 C2.43352941,-3.61111111e-05 2.56305882,4.381325 2.56305882,5.03565833",
    id: "Fill-1",
    fill: "#F1EDE4",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.7b2811ec5fcd85248a5736b7a92e623a.svg";
export { ForwardRef as ReactComponent };